import cookie from 'js-cookie';
import {COOKIES} from './cookies';

export const removeFromCookie = (cookieName: COOKIES): void => {
  cookie.remove(cookieName);
};
